import React, { useCallback } from "react"
import styled from "styled-components"
import CheckItem from "../components/CheckItem"
import { LayoutSplit } from "../components/Layout"
import TrustItem from "../components/TrustItem"
import { SideBySideWidget as Widget } from "../components/Widget"
import image from "../images/Image1680_01@1.jpg"
import ekomi from "../images/siegel_ekomi.png"
import tuev from "../images/TUEV.svg"
import { onPhone, NotPhone, onTablet } from "../theme/MediaQueries"

const PageLayout = styled.div`
  display: flex;
  flex-direction: row;

  & > * {
    flex: 1;
  }

  ${onTablet} {
    padding: 0 16px;
  }

  ${onPhone} {
    flex-direction: column-reverse;
  }
`

const InformationLayout = styled.div`
  display: flex;
  flex-direction: column;

  ${onPhone} {
    flex-direction: column-reverse;
    padding: 0 16px;
  }
`

const HeroImage = styled.img`
  margin: 5px 0 32px 0;
  height: 384px;
  object-fit: cover;
  max-height: 100%;
  max-width: 100%;
`

const TrustContainer = styled.div`
  display: flex;
  flex-direction: row;

  & > * {
    flex: 1;
    padding: 8px;
  }

  ${onPhone} {
    justify-content: space-between;
    flex-direction: row-reverse;
  }

  ${onTablet} {
    flex-wrap: wrap;
    padding: 16px 16px 16px 0;
    & > *:first-child {
      margin-bottom: 16px;
    }
  }
`

const TrustIcon = styled.div`
  &:hover {
    cursor:pointer;
  }
`

const SideBySide = (props) => {
  const openURL = useCallback((url) => () => {
    window.open(url, '_blank', 'noopener');
  }, [])

  return (
    <LayoutSplit>
      <PageLayout>
        <InformationLayout>
          <div>
            <CheckItem>Vergleich von über 80 Bankangeboten</CheckItem>
            <CheckItem>Schnelle Kreditauszahlung</CheckItem>
            <CheckItem>Unverbindliche Anfrage</CheckItem>
          </div>

          <NotPhone>
            <HeroImage src={image} />
          </NotPhone>
          <TrustContainer>
            <TrustIcon onClick={openURL('https://www.ekomi.de/bewertungen-finanzcheck.html')}
            >
              <TrustItem
                image={ekomi}
                title="Höchste Kundenzufriedenheit"
                italic={true}
                body="„Sensationelle Beratung. Ich bin sehr zufrieden mit dem Service und kann es nur weiter empfehlen!“"
                link='https://www.ekomi.de/bewertungen-finanzcheck.html'
              />
            </TrustIcon>
            <TrustIcon onClick={openURL('https://www.tuev-saar.de/zertifikat/tk43790/')}
            >
              <TrustItem
                image={tuev}
                title="TÜV geprüftes Onlineportal"
                body="Einfache Bedienung, sichere Datenübertragung, qualifizierter Kundenservice"
              />
            </TrustIcon>
          </TrustContainer>
        </InformationLayout>

        <Widget text="Träume verwirklichen mit dem besten Kredit schon ab 0,68%*" />
      </PageLayout>
    </LayoutSplit>
  )
}

export default SideBySide
